(function ($, Drupal, window, document) {
    Drupal.behaviors.AndechserMenu = {
        attach: function (context, settings) {

            $(once('hamburger', '.hamburger')).on('click', function () {
                $('.main-nav').slideDown();
                $('.site-main').addClass('blur');
                //console.log('$(\'.site-main\', context).addClass(\'blur\');');
            });
            $(once('main-nav-close', '.main-nav-close')).on('click', function () {
                $('.main-nav').slideUp();
                $('.site-main').removeClass('blur');
                //console.log('$(\'.site-main\', context).removeClass(\'blur\')');
            });


            $(once('menu-level-0', '.menu-level-0 li')).on('click', function () {
                //console.log('test 3');
                $(this).find('.menu-level-1').slideToggle();
                $(this).toggleClass('menu-0-open');
                $(this).siblings().each(function () {
                    $(this).find('.menu-level-1').slideUp();
                    $(this).removeClass('menu-0-open');
                });
            });

            $(once('lang-switch', '.nav-language-switcher ul.links')).on('click', function () {
                $(this).toggleClass('show');
            });

            // Breadcrumb - change text color, if there no green-wave on the header
            if ($('.waves-header, .waves-highlighted, .hero').length < 1) {
                $('#block-breadcrumbs').addClass('color-dark-green');
            }

        }
    }

    Drupal.behaviors.ColorizeAndechserMenu = {
        attach: function (context, settings) {

            // Detect request animation frame
            var scroll = window.requestAnimationFrame
                || window.webkitRequestAnimationFrame
                || window.mozRequestAnimationFrame
                || window.msRequestAnimationFrame
                || window.oRequestAnimationFrame
                // IE Fallback, you can even fallback to onscroll
                || function (callback) {
                    window.setTimeout(callback, 1000 / 60)
                };

            var lastPosition = -1;

            // my Variables
            var replaceItemDimensions = null;
            var replaceItemTop = -1;
            var replaceItemBottom = -1;
            var replaceItemHeight = -1;

            // The Scroll Function
            function loop() {
                var top = window.scrollY;

                // Fire when needed
                if (lastPosition === top) {
                    scroll(loop);
                    return false;
                } else {
                    lastPosition = top;

                    // my sections to calculate stuff
                    var sections = document.querySelectorAll('.hero, section, .site-footer, .waves-highlighted, .waves-header');
                    var replaceItem = document.querySelector('.hamburger');

                    if (replaceItem) {
                        replaceItemDimensions = replaceItem.getBoundingClientRect();
                        // get top position of item from container, because image might not have loaded
                        replaceItemTop = replaceItemDimensions.top;
                        replaceItemHeight = replaceItem.offsetHeight;
                        replaceItemBottom = replaceItemTop + replaceItemHeight;
                    }

                    // wave sine params
                    var menuX = replaceItemDimensions.right - replaceItemHeight / 2;
                    var screenX = document.documentElement.clientWidth;
                    var waveLeft = screenX * 0.21;
                    var waveWidth = screenX - waveLeft;
                    var waveAmpl = screenX * 0.072;

                    var waveY = waveAmpl * Math.sin((menuX - waveLeft) / (waveWidth / Math.PI));

                    // Your Function
                    Array.prototype.forEach.call(sections, function (el, i) {

                        var sectionBefore = i > 0 ? sections[i - 1] : null;
                        var sectionAfter = i < sections.length - 2 ? sections[i + 1] : null;

                        var sectionAfterMarginTop = sectionAfter ? parseInt((sectionAfter.currentStyle || window.getComputedStyle(sectionAfter)).marginTop, 10) : 0;

                        var sectionBeforeHasBottomWave = sectionBefore ? sectionBefore.classList.contains('waves-bottom') || sectionBefore.classList.contains('waves-highlighted') || sectionBefore.querySelectorAll(':scope > .waves-bottom').length > 0 : false;
                        var sectionAfterHasTopWave = sectionAfter ? sectionAfter.querySelectorAll(':scope > .waves-top').length > 0 : false;

                        var hasTopWave = el.querySelectorAll(':scope > .waves-top').length > 0;
                        var hasBottomWave = el.classList.contains('waves-bottom') || el.classList.contains('waves-highlighted') || el.querySelectorAll(':scope > .waves-bottom').length > 0;

                        var sectionTop = el.getBoundingClientRect().top + (hasTopWave ? waveAmpl - waveY : 0) - (sectionBeforeHasBottomWave ? waveY : 0);
                        var sectionBottom = el.getBoundingClientRect().bottom - (hasBottomWave ? waveY : 0) + (sectionAfterHasTopWave ? waveAmpl - waveY : 0) + sectionAfterMarginTop;

                        // active section
                        if ((sectionTop <= replaceItemTop) && (sectionBottom > replaceItemBottom)) {

                            // check if current section has bg
                            var onDark = el.classList.contains('bg-primary') || el.querySelectorAll(':scope > .bg-primary').length > 0;

                            // switch class depending on background image
                            if (onDark) {
                                replaceItem.classList.remove('hamburger--dark');
                            } else {
                                replaceItem.classList.add('hamburger--dark')
                            }
                        }
                        // end active section

                    });

                }

                // Recall the loop
                scroll(loop)
            }

            // Call the loop for the first time
            loop();

            window.onresize = function (event) {
                loop();
            };
        }
    }


})(jQuery, Drupal, window, document);
